// extracted by mini-css-extract-plugin
export default {"smartNavLink":"styles_smart-nav-link_B8DnT","active":"styles_active_dHVgB","border":"styles_border_CU_NP"};